import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SENSORS from '@/constants/sensor';
import { TEMPLATE_PREVIEW } from '@/constants/jsbridge';
import Styles from './index.module.scss';

const MoreTemplateButton = ({
  className,
  isLight,
  isLast,
  pageTitle,
  selectedTpl,
  createButtonProps,
  moreButtonProps,
  onSlideNext,
  onRedirect,
  onSensorTrack,
}) => {
  const handleClick = () => {
    onSensorTrack(SENSORS.LIGHT_H5_VIDEO_TRYNOW_CLICK, {
      model_name: selectedTpl.name,
      model_tab: pageTitle,
    });
    const jumpParams = {
      path: TEMPLATE_PREVIEW,
      query: { code: selectedTpl.code },
    };
    onRedirect(jumpParams);
  };

  return isLight ? (
    <div className={cx(Styles.lightRoot, className)} aria-hidden onClick={isLast ? () => {} : onSlideNext}>
      <div style={{ color: moreButtonProps.color }}>
        { isLast ? '没有更多了' : (moreButtonProps.label || '更多模板') }
      </div>
      {
        !isLast && <div className={Styles.icon} />
      }
    </div>
  ) : (
    <div className={cx(Styles.notLightRoot, className)}>
      <div className={Styles.button} style={{ color: createButtonProps.color }} aria-hidden onClick={handleClick}>
        { createButtonProps.label || '制作同款' }
      </div>
    </div>
  );
};

MoreTemplateButton.propTypes = {
  className: PropTypes.string,
  isLast: PropTypes.bool,
  isLight: PropTypes.bool,
  pageTitle: PropTypes.string,
  selectedTpl: PropTypes.shape({}),
  createButtonProps: PropTypes.shape({}),
  moreButtonProps: PropTypes.shape({}),
  onSlideNext: PropTypes.func,
  onRedirect: PropTypes.func,
  onSensorTrack: PropTypes.func,
};

MoreTemplateButton.defaultProps = {
  className: '',
  isLast: false,
  isLight: false,
  pageTitle: '',
  selectedTpl: {},
  jsBridgeProps: {},
  createButtonProps: {},
  moreButtonProps: {},
  onSlideNext: () => true,
  onRedirect: () => true,
  onSensorTrack: () => true,
};

export default MoreTemplateButton;
